import { Box, TextField } from "@mui/material";
import { useStyles } from "./style";
import { StarIcon } from "./icons";

interface InputProps {
  label: string;
  required?: boolean;
  placeholder?: string;
  value?: string;
  onChange?: (value: string) => void;
  givenHeight?: string;
  disabled?: boolean;
}

export const Input = ({
  label,
  required,
  placeholder,
  value,
  onChange,
  givenHeight,
  disabled,
}: InputProps) => {
  const classes = useStyles();
  return (
    <Box className={classes.container}>
      <Box className={classes.labelWrapper}>
        <Box className={required ? classes.labelRequired : classes.label}>
          {label}
        </Box>
        {required && (
          <Box className={classes.icon}>
            <StarIcon width={6.957} height={7.875} />
          </Box>
        )}
      </Box>
      <Box sx={{ width: "100%" }}>
        <TextField
          variant="outlined"
          fullWidth
          placeholder={placeholder}
          value={value}
          onChange={(e) => onChange?.(e.target.value)}
          disabled={disabled}
          sx={{
            "& .MuiOutlinedInput-root": {
              borderRadius: "10px",
              height: givenHeight || "44px",
              fontSize: "14px",
              backgroundColor: "white",
            },
            "& .MuiOutlinedInput-notchedOutline": {
              borderColor: "#B9BEC7",
            },
          }}
        />
      </Box>
    </Box>
  );
};
